import type { TableColumnsType } from "antd";
import { opportunityApi } from "api/opportunity.api";
import { AppTable } from "components/antd-ui";
import { CodeCell, StatusCell, TableContent } from "components/table";
import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Opportunity } from "types/opportunity";
import { formatDate } from "utils/date";
import { OPPORTUNITY_PATH, formatMoney, opportunityStatusTrans } from "views/Opportunity/opportunity.meta";
import { useCustomerList } from "./useCustomerList";

// Tab "Cơ hội": cơ hội chưa được duyệt báo giá — hiển thị trạng thái nội bộ
export const CustomerOpportunityTab = ({ customerId }: { customerId: number }) => {
  const navigate = useNavigate();

  const fetcher = useCallback(async (params: Record<string, unknown>) => {
    const res = await opportunityApi.findAll({ ...params, hasQuote: "false", countScope: "opportunity" });
    return { items: (res.data.opportunitys || []) as Opportunity[], total: res.data.total || 0 };
  }, []);

  const { items, loading, pagination } = useCustomerList<Opportunity>(customerId, fetcher);

  const columns = useMemo<TableColumnsType<Opportunity>>(
    () => [
      { title: "Mã", dataIndex: "code", key: "code", width: 140, render: (value) => <CodeCell value={value || "--"} /> },
      { title: "Tên cơ hội", dataIndex: "name", key: "name", render: (value) => <TableContent>{value || "--"}</TableContent> },
      {
        title: "Trạng thái",
        dataIndex: "status",
        key: "status",
        width: 180,
        render: (value) => <StatusCell value={value} trans={opportunityStatusTrans} />,
      },
      {
        title: "Tổng tiền",
        dataIndex: "totalAmount",
        key: "totalAmount",
        width: 150,
        align: "right",
        render: (value: number) => formatMoney(value || 0),
      },
      {
        title: "Ngày tạo",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 120,
        render: (value: number) => (value ? formatDate(value) : "--"),
      },
    ],
    [],
  );

  return (
    <AppTable<Opportunity>
      className="customerTabTable"
      rowKey="id"
      size="small"
      loading={loading}
      dataSource={items}
      columns={columns}
      pagination={pagination}
      locale={{ emptyText: "Chưa có cơ hội" }}
      onRow={(record) => ({ onClick: () => navigate(`${OPPORTUNITY_PATH}/${record.id}`) })}
    />
  );
};
